import { IMyTeam } from "@/core/interfaces/salesMyTeam.interface";
import {
  ISalesSector,
  ISalesSnapshot,
} from "@/core/interfaces/salesProductivity.interface";
import { ISalesState } from "@/core/interfaces/salesState.interface";
import { ISectorProductivity } from "@/core/interfaces/sectorProductivity.interface";
import { StoreState } from "@/store/type";
import { GetterTree } from "vuex";

const getters: GetterTree<ISalesState, StoreState> = {
  salesSectors: (state): Array<ISalesSector> | null => state.sectors,
  isSalesSectorsFetching: (state): boolean => state.isSalesSectorsFetching,
  isSalesLoading: (state): boolean => state.isLoading,
  salesSnapshot: (state): ISalesSnapshot | null => state.salesSnapshot,
  salesProductivity: (state): ISectorProductivity | null =>
    state.salesProductivity,
  isSalesMyTeamLoading: (state): boolean => state.isSalesMyTeamLoading,
  salesMyTeam: (state): IMyTeam[] => state.salesMyTeam,
};

export default getters;
